import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import classNames from 'classnames';
import { isAfter } from 'date-fns';

import './Category.scss';
import { getFlag } from '../../../utils/utils';
import Icon from '../../Icon/Icon';
import RaceEvent from '../RaceEvent/RaceEvent';

export interface CategoryProps {
  tournaments: {
    name: string,
    countryCode: string,
    country: string,
    categoryCode: number,
    code: number,
    eventStart: number,
    tournamentCode: number,
    events: {
      eventCode: number,
      status: string,
      statusCode: number,
    }[],
    meetingInfos: {
      timeNextRace: number,
      nextRaceNo: number,
      noRaces: number,
      meetingCode: number,
      hasToteMarkets: boolean,
      hasFoMarkets: boolean
    }
  }[]
  isSearch?: boolean
}

export default function Category({ tournaments, isSearch = false }: CategoryProps) {
  const [hideCategory, setHideCategory] = useState(false);

  const { t } = useTranslation('common');

  const toggleCategory = () => {
    setHideCategory(!hideCategory);
  };

  const renderTournament = useCallback(() => {
    return _.map(tournaments, tournament => {
      const nextEvent = _.find(tournament.events, (evt) => evt.statusCode === 1);

      return (
        <div
          className={
            classNames('category__venue-row', {
              'category__race-horse-racing ': tournament.code === 201 || tournament.code === 202,
              'category__race-greyhound': tournament.code === 204,
              'category__race-trot': tournament.code === 203
            })
          }
          key={ tournament.code + tournament.eventStart + tournament.events[0]?.eventCode }
        >
          <div className="category__tournament-description">
            <div className="category__venue-details-container">
              {
                nextEvent ?
                  <Link
                    className="category__venue-name"
                    title={ tournament.name }
                    to={ tournament.meetingInfos ? `/racing/${ tournament.meetingInfos.meetingCode }/${ nextEvent.eventCode } ` : '#' }
                  >
                    { tournament.name }
                  </Link>
                  :
                  <div className="category__venue-name">{ tournament.name }</div>
              }
              {
                (tournament.meetingInfos && isAfter(tournament.meetingInfos.timeNextRace * 1000, new Date())) ?
                  <div className="category__venue-sum">{ tournament.meetingInfos.nextRaceNo + '/' +tournament.meetingInfos.noRaces }</div>
                  :
                  <div className="category__venue-sum">-/-</div>
              }
            </div>

            {
              !isSearch && <div className="category__venue-buttons">
                <Link
                  className={
                    classNames('category__venue-button', {
                      'category__venue-button--disabled': !tournament.meetingInfos.hasToteMarkets })
                  }
                  title={ !nextEvent ? t('horseDetail.noOpenEvents') : '' }
                  to={ nextEvent && tournament.meetingInfos ? `/racing/${ tournament.meetingInfos.meetingCode }/${ nextEvent.eventCode }/tote` : '#' }
                >
                  { t('horseDetail.t') }
                </Link>
                <Link
                  className={
                    classNames('category__venue-button', {
                      'category__venue-button--disabled': !tournament.meetingInfos.hasFoMarkets })
                  }
                  title={ !nextEvent ? t('horseDetail.noOpenEvents') : '' }
                  to={
                    nextEvent && tournament.meetingInfos
                      ?
                      `/racing/${ tournament.meetingInfos.meetingCode }/${ nextEvent.eventCode }/fixed-odds`
                      :
                      '#'
                  }
                >
                  { t('horseDetail.fo') }
                </Link>
              </div>
            }
          </div>

          {
            tournament.events.length > 0 &&
              <RaceEvent events={ tournament.events } meetingCode={ tournament.meetingInfos ? tournament.meetingInfos.meetingCode : 0 } />
          }
        </div>
      );
    });
  }, [tournaments]);

  return (
    <div className="category">
      <div className="category__container" onClick={ toggleCategory }>
        <div className="category__flags-container">
          <div className="category__flags" style={ { backgroundImage: `url(${ getFlag(tournaments[0]?.countryCode) })` } } />
          <div className="category__title">{ tournaments[0]?.country }</div>
        </div>

        <Icon
          icon="arrow"
          className={
            classNames({
              'category__down-arrow': !hideCategory,
              'category__up-arrow': hideCategory
            })
          }
          onClick={ toggleCategory }
        />
      </div>

      { !hideCategory && renderTournament() }
    </div>
  );
}
